export default __webpack_public_path__ + "static/media/home-travel-agency-tour-intrest-img01.369f1954.jpg";